import { request } from "../axios/request";

export const getRelaySwitchesService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/relay-switches", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const getAllRelaySwitchesService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/relay-switches", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const saveRelaySwitchService = (data, id = 0) => {
  if (id > 0) {
    return async (dispatch, getState) => {
      return dispatch(
        request("/relay-switches/" + id, getState(), {
          method: "PUT",
          data,
        })
      );
    };
  }
  return async (dispatch, getState) => {
    return dispatch(
      request("/relay-switches", getState(), {
        method: "POST",
        data,
      })
    );
  };
};

export const deleteRelaySwitchService = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/relay-switches/" + id, getState(), {
        method: "DELETE",
      })
    );
  };
};
